import { regEx } from "./constant";
import CryptoJS from 'crypto-js';

export function isValidNumber(number) {
    const numberRegex = RegExp(regEx.number);
    return numberRegex.test(number)
}

export function isValidAlphaNumeric(value) {
    const alphaNumericRegex = RegExp(regEx.alphaNumeric);
    return alphaNumericRegex.test(value);
}

export function isValidPAN(value) {
    const panRegex = RegExp(regEx.pan);
    return panRegex.test(value);
}

export function fetchWithWait({ dispatch, action }) {
    return new Promise((resolve, reject) => {
        dispatch({ ...action, resolve, reject })
    })
}

export function isValidEmail(email) {
    const emailRegex = RegExp(regEx.email);
    return emailRegex.test(email)
}
export function isValidName(name) {
    const panRegex = RegExp(regEx.line);
    return panRegex.test(name)
}

export function isValidAlphabates(value) {
    const alphaRegex = RegExp(regEx.alphabates);
    return alphaRegex.test(value);
}

export function convertDate(date) {
    const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    let formatted_date = date.getFullYear() + "-" + (months[date.getMonth()]) + "-" + date.getDate();
    return formatted_date
}
export function formatDateofmonth(date) {
    const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    const formatDate = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25",
        "26", "27", "28", "29", "30", "31",];
    let formatted_date = date.getFullYear() + "-" + (months[date.getMonth()]) + "-" + (formatDate[date.getDate() - 1]);
    return formatted_date
}

export function convertISOFormat(date) {
    date = new Date(date)
    //getting date format issue in pdf and excel so changed
    // let formatted_date = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    let formatted_date = date.getDate() + "-" + (months[date.getMonth()]) + "-" + date.getFullYear();
    return formatted_date
}

export function passwordRegEx(pass) {
    const numberRegex = RegExp(regEx.pwdConfirm);
    return numberRegex.test(pass)
}

export function isValidOtp(otp) {
    const otpRegex = RegExp(regEx.otpRegex);
    return otpRegex.test(otp);
}

export function numberText(data) {
    let check = RegExp(regEx.number);
    return check.test(data);
}

export function encrypt(text, key) {
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Hex.parse(key), {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return iv.toString(CryptoJS.enc.Hex) + ':' + encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}

export function decrypt(text, key) {
    const parts = text.split(':');
    const iv = CryptoJS.enc.Hex.parse(parts.shift());
    const encryptedText = CryptoJS.enc.Hex.parse(parts.join(':'));
    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedText },
        CryptoJS.enc.Hex.parse(key),
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
}

export const setEncryptedItem = (key, value) => {
    try {
        const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), process.env.REACT_APP_ENC_KEY).toString();
        localStorage.setItem(key, encryptedValue);
    } catch (error) {
        console.error("Error storing encrypted data in localStorage:", error);
    }
};

export const getDecryptedItem = (key) => {
    try {
        const encryptedValue = localStorage.getItem(key);
        if (!encryptedValue) return null;

        const decryptedValue = CryptoJS.AES.decrypt(encryptedValue, process.env.REACT_APP_ENC_KEY).toString(CryptoJS.enc.Utf8);
        let parsedValue;
        try {
            parsedValue = JSON.parse(decryptedValue);
        } catch {
            parsedValue = JSON.parse(JSON.parse(decryptedValue));
        }

        return parsedValue;
    } catch (error) {
        console.error("Error retrieving or decrypting data from localStorage:", error);
        return null;
    }
};